<template>
  <div>
    <div v-if="loading" class="flex justify-center items-center min-h-[200px]">
      <div class="w-12 h-12 border-b-2 rounded-full animate-spin border-custom-yellow"></div>
    </div> 
    <template v-else>
    <div class="relative mt-5 overflow-x-auto shadow-md sm:rounded-lg">
      <table class="w-full text-left text-gray-700 rtl:text-right">
        <thead>
          <tr class="bg-gray-100"> 
            <th scope="col" class="p-4">
              <div class="flex items-center">
                <input id="checkbox-all-search" type="checkbox"
                  class="w-4 h-4 bg-gray-100 border-gray-300 rounded text-custom-yellow focus:ring-custom-yellow dark:focus:ring-custom-yellow dark:ring-offset-gray-800 dark:focus:ring-offset-gray-800 focus:ring-2 dark:bg-gray-700 dark:border-gray-600">
                <label for="checkbox-all-search" class="sr-only">checkbox</label>
              </div>
            </th>
            <th scope="col" class="px-6">
              <div class="flex items-center">
                Serial no.
                <a href="#"><svg class="w-3 h-3 ms-1.5" aria-hidden="true" xmlns="http://www.w3.org/2000/svg"
                    fill="currentColor" viewBox="0 0 24 24">
                    <path
                      d="M8.574 11.024h6.852a2.075 2.075 0 0 0 1.847-1.086 1.9 1.9 0 0 0-.11-1.986L13.736 2.9a2.122 2.122 0 0 0-3.472 0L6.837 7.952a1.9 1.9 0 0 0-.11 1.986 2.074 2.074 0 0 0 1.847 1.086Zm6.852 1.952H8.574a2.072 2.072 0 0 0-1.847 1.087 1.9 1.9 0 0 0 .11 1.985l3.426 5.05a2.123 2.123 0 0 0 3.472 0l3.427-5.05a1.9 1.9 0 0 0 .11-1.985 2.074 2.074 0 0 0-1.846-1.087Z" />
                  </svg></a>
              </div>
            </th>
            <th scope="col" class="px-6">
              <div class="flex items-center">
                Blood Group
                <a href="#"><svg class="w-3 h-3 ms-1.5" aria-hidden="true" xmlns="http://www.w3.org/2000/svg"
                    fill="currentColor" viewBox="0 0 24 24">
                    <path
                      d="M8.574 11.024h6.852a2.075 2.075 0 0 0 1.847-1.086 1.9 1.9 0 0 0-.11-1.986L13.736 2.9a2.122 2.122 0 0 0-3.472 0L6.837 7.952a1.9 1.9 0 0 0-.11 1.986 2.074 2.074 0 0 0 1.847 1.086Zm6.852 1.952H8.574a2.072 2.072 0 0 0-1.847 1.087 1.9 1.9 0 0 0 .11 1.985l3.426 5.05a2.123 2.123 0 0 0 3.472 0l3.427-5.05a1.9 1.9 0 0 0 .11-1.985 2.074 2.074 0 0 0-1.846-1.087Z" />
                  </svg></a>
              </div>
            </th>
            <th scope="col" class="px-6">
              <div class="flex items-center">
                Blood Product
                <a href="#"><svg class="w-3 h-3 ms-1.5" aria-hidden="true" xmlns="http://www.w3.org/2000/svg"
                    fill="currentColor" viewBox="0 0 24 24">
                    <path
                      d="M8.574 11.024h6.852a2.075 2.075 0 0 0 1.847-1.086 1.9 1.9 0 0 0-.11-1.986L13.736 2.9a2.122 2.122 0 0 0-3.472 0L6.837 7.952a1.9 1.9 0 0 0-.11 1.986 2.074 2.074 0 0 0 1.847 1.086Zm6.852 1.952H8.574a2.072 2.072 0 0 0-1.847 1.087 1.9 1.9 0 0 0 .11 1.985l3.426 5.05a2.123 2.123 0 0 0 3.472 0l3.427-5.05a1.9 1.9 0 0 0 .11-1.985 2.074 2.074 0 0 0-1.846-1.087Z" />
                  </svg></a>
              </div>
            </th>
            <th scope="col" class="px-6">
              <div class="flex items-center">
                Volume
                <a href="#"><svg class="w-3 h-3 ms-1.5" aria-hidden="true" xmlns="http://www.w3.org/2000/svg"
                    fill="currentColor" viewBox="0 0 24 24">
                    <path
                      d="M8.574 11.024h6.852a2.075 2.075 0 0 0 1.847-1.086 1.9 1.9 0 0 0-.11-1.986L13.736 2.9a2.122 2.122 0 0 0-3.472 0L6.837 7.952a1.9 1.9 0 0 0-.11 1.986 2.074 2.074 0 0 0 1.847 1.086Zm6.852 1.952H8.574a2.072 2.072 0 0 0-1.847 1.087 1.9 1.9 0 0 0 .11 1.985l3.426 5.05a2.123 2.123 0 0 0 3.472 0l3.427-5.05a1.9 1.9 0 0 0 .11-1.985 2.074 2.074 0 0 0-1.846-1.087Z" />
                  </svg></a>
              </div>
            </th>
            <th scope="col" class="px-6">
              <div class="flex items-center">
                Origin
                <a href="#"><svg class="w-3 h-3 ms-1.5" aria-hidden="true" xmlns="http://www.w3.org/2000/svg"
                    fill="currentColor" viewBox="0 0 24 24">
                    <path
                      d="M8.574 11.024h6.852a2.075 2.075 0 0 0 1.847-1.086 1.9 1.9 0 0 0-.11-1.986L13.736 2.9a2.122 2.122 0 0 0-3.472 0L6.837 7.952a1.9 1.9 0 0 0-.11 1.986 2.074 2.074 0 0 0 1.847 1.086Zm6.852 1.952H8.574a2.072 2.072 0 0 0-1.847 1.087 1.9 1.9 0 0 0 .11 1.985l3.426 5.05a2.123 2.123 0 0 0 3.472 0l3.427-5.05a1.9 1.9 0 0 0 .11-1.985 2.074 2.074 0 0 0-1.846-1.087Z" />
                  </svg></a>
              </div>
            </th>
<th scope="col" class="px-6">
                <div class="flex items-center">
                  Donation Date (mm/dd/yyyy)
                  <a href="#"><svg class="w-3 h-3 ms-1.5" aria-hidden="true" xmlns="http://www.w3.org/2000/svg"
                      fill="currentColor" viewBox="0 0 24 24">
                      <path
                        d="M8.574 11.024h6.852a2.075 2.075 0 0 0 1.847-1.086 1.9 1.9 0 0 0-.11-1.986L13.736 2.9a2.122 2.122 0 0 0-3.472 0L6.837 7.952a1.9 1.9 0 0 0-.11 1.986 2.074 2.074 0 0 0 1.847 1.086Zm6.852 1.952H8.574a2.072 2.072 0 0 0-1.847 1.087 1.9 1.9 0 0 0 .11 1.985l3.426 5.05a2.123 2.123 0 0 0 3.472 0l3.427-5.05a1.9 1.9 0 0 0 .11-1.985 2.074 2.074 0 0 0-1.846-1.087Z" />
                    </svg></a>
                </div>
              </th>
              <th scope="col" class="px-6">
                <div class="flex items-center">
                  Expiry Date (mm/dd/yyyy)
                  <a href="#"><svg class="w-3 h-3 ms-1.5" aria-hidden="true" xmlns="http://www.w3.org/2000/svg"
                      fill="currentColor" viewBox="0 0 24 24">
                      <path
                        d="M8.574 11.024h6.852a2.075 2.075 0 0 0 1.847-1.086 1.9 1.9 0 0 0-.11-1.986L13.736 2.9a2.122 2.122 0 0 0-3.472 0L6.837 7.952a1.9 1.9 0 0 0-.11 1.986 2.074 2.074 0 0 0 1.847 1.086Zm6.852 1.952H8.574a2.072 2.072 0 0 0-1.847 1.087 1.9 1.9 0 0 0 .11 1.985l3.426 5.05a2.123 2.123 0 0 0 3.472 0l3.427-5.05a1.9 1.9 0 0 0 .11-1.985 2.074 2.074 0 0 0-1.846-1.087Z" />
                    </svg></a>
                </div>
              </th>
            <th scope="col" class="px-6">
              <div class="flex items-center">
                Status
                <a href="#"><svg class="w-3 h-3 ms-1.5" aria-hidden="true" xmlns="http://www.w3.org/2000/svg"
                    fill="currentColor" viewBox="0 0 24 24">
                    <path
                      d="M8.574 11.024h6.852a2.075 2.075 0 0 0 1.847-1.086 1.9 1.9 0 0 0-.11-1.986L13.736 2.9a2.122 2.122 0 0 0-3.472 0L6.837 7.952a1.9 1.9 0 0 0-.11 1.986 2.074 2.074 0 0 0 1.847 1.086Zm6.852 1.952H8.574a2.072 2.072 0 0 0-1.847 1.087 1.9 1.9 0 0 0 .11 1.985l3.426 5.05a2.123 2.123 0 0 0 3.472 0l3.427-5.05a1.9 1.9 0 0 0 .11-1.985 2.074 2.074 0 0 0-1.846-1.087Z" />
                  </svg></a>
              </div>
            </th>
            <th scope="col" class="px-6">
              Action
            </th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(product, index) in products" :key="product.product_id" class="border-b">
            <td class="w-4 p-4">
              <div class="flex items-center">
                <input :id="'checkbox-table-search-' + index" type="checkbox" class="w-4 h-4">
                <label :for="'checkbox-table-search-' + index" class="sr-only">checkbox</label>
              </div>
            </td>
            <td class="px-6 py-2">{{ product.pint_serial }}</td>
            <td class="px-6 py-2">{{ product.blood_group?.description }}</td>
            <td class="px-6 py-2">{{ product.unit_product?.name }}</td>
            <td class="px-6 py-2">{{ product.volume || '0' }} ml</td>
            <td class="px-6 py-2 text-sm">{{ product.source || product.blood_donation?.origin }}</td>
            <td class="px-6 py-2">{{ product.blood_donation?.date_added ? new Date(product.blood_donation.date_added).toLocaleString() : 'User specified' }}</td>
            <td class="px-6 py-2">{{ product.expiry_date ? new Date(product.expiry_date).toLocaleString() : 'User specified' }}</td>
            <td class="px-6 py-2 text-center">
              <span
                class="p-2 rounded-lg min-w-[100px] text-center inline-block"
                :class="{
                  'bg-green-50 text-green-500': ['Okay', 'Segregated'].includes(product.status),
                  'bg-red-50 text-red-500': ['Expired'].includes(product.status),
                  'bg-blue-50 text-blue-500': ['Assigned'].includes(product.status),
                  'bg-orange-50 text-orange-500': ['Issued'].includes(product.status) || product.facility_issuing,
                  'bg-gray-50 text-gray-500': ['Transfused'].includes(product.status),
                }"
              >
                {{ product.facility_issuing && facility_code === 'KTTA' ? `Issued to ${product.facility?.name || 'External Facility'}` : product.status }}
              </span>
            </td>
            <td class="flex items-center px-6 py-2">
              <CustomButton label="View Details" @click="handleViewDetails(product.product_id)"
              :disabled="isLoading[product.product_id]" 
              :bg-class="isLoading[product.product_id] ? 'bg-gray-300 cursor-not-allowed' : 'bg-custom-yellow text-sm py-1'" />
              <CustomButton label="Print sticker" @click="handlePrintSticker(product.product_id)"
              :disabled="isLoading[product.product_id]" 
              :bg-class="isLoading[product.product_id] ? 'bg-gray-300 cursor-not-allowed' : 'bg-custom-blue text-sm py-1 ml-2'" />
              <div v-if="isLoading[product.product_id]" class="w-5 h-5 ml-2 border-t-2 border-b-2 border-gray-900 rounded-full animate-spin"></div>
            </td>
                        </tr>
                        <tr v-if="loadingMore">
                            <td colspan="10" class="py-4 text-center">
                                <div class="flex items-center justify-center">
                                    <div class="w-8 h-8 border-b-2 rounded-full animate-spin border-custom-yellow"></div>
                                    <span class="ml-2 text-gray-600">Loading more products...</span>
                                </div>
                            </td>
                        </tr>
                        <tr v-if="!hasMore && products.length > 0 && !loadingMore">
                            <td colspan="10" class="py-4 text-center text-gray-500">
                                No more products to load
                            </td>
                        </tr>
                    </tbody>
      </table>
    </div>
    <p class="mb-2 text-center text-gray-600">{{ showingText }}</p>
    <div class="flex justify-center gap-4 mt-4">
      <button @click="previousPage" :disabled="currentPage === 1"
        class="flex items-center gap-2 px-6 py-3 font-bold text-center align-middle transition-all rounded-lg select-none text-custom-blue hover:bg-custom-blue/10 active:bg-custom-blue/20 disabled:pointer-events-none disabled:opacity-50 disabled:shadow-none"
        type="button">
        <svg class="w-6 h-6" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none"
          viewBox="0 0 24 24">
          <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
            d="m15 19-7-7 7-7" />
        </svg>
        Previous
      </button>

      <div class="flex items-center gap-2">
        <button v-for="page in visiblePages" :key="page" @click="goToPage(page)" :class="{
          'bg-custom-blue text-white': page === currentPage,
          'text-custom-blue': page !== currentPage
        }"
          class="relative h-10 max-h-[40px] w-10 max-w-[40px] select-none rounded-lg text-center align-middle font-medium transition-all hover:bg-custom-blue/10 active:bg-custom-blue/20 disabled:pointer-events-none disabled:opacity-50 disabled:shadow-none"
          type="button">
          <span class="absolute transform -translate-x-1/2 -translate-y-1/2 top-1/2 left-1/2">
            {{ page }}
          </span>
        </button>
      </div>

      <button @click="nextPage" :disabled="currentPage === totalPages"
        class="flex items-center gap-2 px-6 py-3 font-bold text-center align-middle transition-all rounded-lg select-none text-custom-blue hover:bg-custom-blue/10 active:bg-custom-blue/20 disabled:pointer-events-none disabled:opacity-50 disabled:shadow-none"
        type="button">
        Next
        <svg class="w-6 h-6" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none"
          viewBox="0 0 24 24">
          <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
            d="m9 5 7 7-7 7" />
        </svg>
      </button>
    </div>
</template>
  </div>
</template>

<script>
import CustomButton from '@/components/CustomButton.vue';
import api from '@/services/api';
// import hospitalLogo from '@/assets/images/Jiji-Health-Blue-Logo.png';
import JsBarcode from 'jsbarcode'

export default {
  name: 'LiveCounterTab',
  components: {
    CustomButton,
  },
  
  props: {
    searchQuery: {
      type: String,
      default: ''
    }
  },

data() {
    return {
      currentPage: 1,
      totalPages: 0,
      totalCount: 0,
      perPage: 10,
      loading: false,
      loadingMore: false,
      hasMore: true,
      debounceTimer: null,
      facility_code: null,
      isLoading: {},
      donations: [],
      products: [],
      error: null,
      filters: {
        bloodGroup: '',
        dateRegistered: '',
        status: '',
        unitProduct: '',
        expiry_days: null
      }
    }
  },
  created() {
    this.loadInitialProducts();
  },
  mounted() {
      this.userData = this.$store.getters["auth/user"];
      this.facility_logo = this.userData.user_roles[0]?.facility_department?.facility?.logo;
      this.facility_code = this.userData?.user_roles[0]?.facility_department?.facility?.facility_code || '';
      window.addEventListener('scroll', this.handleScroll);
  },
  beforeUnmount() {
      window.removeEventListener('scroll', this.handleScroll);
  },
  computed: {
    visiblePages() {
      return this.calculatePageRange();
    },
    showingText() {
      if (this.loading && this.products.length === 0) return "Loading...";
      if (this.products.length === 0) return "No products found";
      const end = this.products.length;
      return `Showing 1-${end} of ${this.totalCount}`;
    }
  },
   watch: {
      filters: { deep: true, handler: 'loadInitialProducts' },
      searchQuery: {
        handler() {
          clearTimeout(this.debounceTimer);
          this.debounceTimer = setTimeout(() => {
            this.loadInitialProducts();
          }, 300);
        }
      }
    },
   methods: {
      formatDate(date) {
        if (!date) return 'N/A';
        const parsedDate = new Date(date);
        if (isNaN(parsedDate.getTime())) {
          console.error("Invalid date:", date);
          return null;
        }

        return parsedDate.toISOString().split('T')[0];
      },

filterExpiry() {
         this.filters.expiry_days = this.filters.expiry_days ? null : 10;
         this.currentPage = 1;
         this.getBloodProducts();
       },

     applyFilters(filters) {
       this.filters = { ...this.filters, ...filters };
       this.currentPage = 1;
     },

     resetFilters() {
       this.filters = {
         bloodGroup: '',
         dateRegistered: '',
         status: '',
         unitProduct: '',
         expiry_days: null
       };
       this.currentPage = 1;
     },

    async handleViewDetails(productId) {
      this.isLoading[productId] = true;
      try {
        await new Promise(resolve => setTimeout(resolve, 500)); 
      if (productId) {
        this.$router.push({
          name: 'ProductDetailsPage',
          params: { product_id: productId }
        });
      } else {
        console.error('Invalid productId');
      } 
    } catch {
        this.isLoading[productId] = false
     }
    },

        async getBloodProducts() {
      this.loading = true;
      try {
        const queryParams = { ...this.filters, search_query: this.searchQuery, page: this.currentPage, per_page: this.perPage };
        const response = await api.fetchFilteredProducts(queryParams);
        this.products = response.data || response;
        this.currentPage = response.current_page;
        this.totalPages = response.total_pages;
        this.totalCount = response.total_count || this.totalPages * this.perPage;
        this.hasMore = this.currentPage < this.totalPages;
      } catch (error) {
        console.error("Error fetching products:", error);
      } finally {
        this.loading = false;
      }
    },

    resetPagination() {
      this.currentPage = 1;
      this.totalPages = 0;
      this.totalCount = 0;
      this.products = [];
      this.hasMore = true;
    },

    handleScroll() {
      if (this.loadingMore || !this.hasMore) return;

      const scrollPosition = window.innerHeight + window.scrollY;
      const threshold = document.body.offsetHeight - 200;

      if (scrollPosition >= threshold) {
        this.loadMore();
      }
    },

    async loadInitialProducts() {
      this.loading = true;
      this.resetPagination();
      try {
        const queryParams = { ...this.filters, search_query: this.searchQuery, page: 1, per_page: this.perPage };
        const response = await api.fetchFilteredProducts(queryParams);
        this.products = response.data || response;
        this.currentPage = response.current_page;
        this.totalPages = response.total_pages;
        this.totalCount = response.total_count || this.totalPages * this.perPage;
        this.hasMore = this.currentPage < this.totalPages;
      } catch (error) {
        console.error("Error fetching products:", error);
      } finally {
        this.loading = false;
      }
    },

    async loadMore() {
      if (this.loadingMore || !this.hasMore) return;

      this.loadingMore = true;
      try {
        const nextPage = this.currentPage + 1;
        const queryParams = { ...this.filters, search_query: this.searchQuery, page: nextPage, per_page: this.perPage };
        const response = await api.fetchFilteredProducts(queryParams);
        this.products = [...this.products, ...(response.data || response)];
        this.currentPage = response.current_page;
        this.totalPages = response.total_pages;
        this.totalCount = response.total_count || this.totalPages * this.perPage;
        this.hasMore = this.currentPage < this.totalPages;
      } catch (error) {
        console.error("Error fetching more products:", error);
      } finally {
        this.loadingMore = false;
      }
    },

    async fetchPage(page) {
      this.loading = true;
      try {
        const queryParams = { ...this.filters, search_query: this.searchQuery, page: page, per_page: this.perPage };
        const response = await api.fetchFilteredProducts(queryParams);
        this.products = response.data || response;
        this.currentPage = response.current_page;
        this.totalPages = response.total_pages;
        this.totalCount = response.total_count || this.totalPages * this.perPage;
        this.hasMore = this.currentPage < this.totalPages;
      } catch (error) {
        console.error("Error fetching products:", error);
      } finally {
        this.loading = false;
      }
    },

    goToPage(page) {
      if (page >= 1 && page <= this.totalPages) {
        this.fetchPage(page);
      }
    },
    async previousPage() {
      if (this.currentPage > 1) {
        await this.fetchPage(this.currentPage - 1);
      }
    },
        async nextPage() {
      if (this.currentPage < this.totalPages) {
        await this.fetchPage(this.currentPage + 1);
      }
    },

    calculatePageRange() {
      const maxPagesToShow = 5;
      let startPage = Math.max(1, this.currentPage - Math.floor(maxPagesToShow / 2));
      let endPage = Math.min(this.totalPages, startPage + maxPagesToShow - 1);

      if (endPage - startPage + 1 < maxPagesToShow) {
        startPage = Math.max(1, endPage - maxPagesToShow + 1);
      }

      return Array.from(
        { length: endPage - startPage + 1 },
        (_, i) => startPage + i
      );
    },

    async handlePrintSticker(productId) {
      this.isLoading[productId] = true;

      const printWindow = document.createElement('iframe');
      printWindow.style.position = 'absolute';
      printWindow.style.width = '0';
      printWindow.style.height = '0';
      document.body.appendChild(printWindow);

      try {
        await new Promise(resolve => setTimeout(resolve, 500)); 

        const response = await api.fetchSingleProduct(productId);
        const product = response.data || response;

        // Call the method to generate barcode
        const barcodeSrc = this.generateBarcode(product.pint_serial);
        const assignedNumber = product.blood_donation?.donor?.assigned_number || '';

        // Prepare print content
        const printContent = `
        <div class="page-container">
          <div class="sticker-container">
            <div class="logo-container">
              <img src="${this.facility_logo}" alt="Hospital Logo" class="logo">
            </div>
            <div class="blood-group-container">
              <div class="${product.blood_group?.description.includes('positive') ? 'blood-group' : 'blood-group hollow-text'}">
                <h1>${product.blood_group?.name || 'N/A'}</h1>
                <p>RH D ${product.blood_group?.description.includes('positive') ? 'Positive' : 'Negative'}</p>
              </div>
              <div class="product-info">
                <p>Bag No:<strong> ${product.pint_serial || 'N/A'}</strong></p>
                <p>Product:<strong> ${product.unit_product?.description || 'N/A'}</strong></p>
                <p>Volume:<strong> ${product.volume || 'N/A'} ml</strong></p>
                ${assignedNumber ? `<p>Donor Number:<strong> ${assignedNumber}</strong></p>` : ''}
              </div>
            </div>
            <p class="negative-results">Negative for <strong>HIV1&2, HCV, HBsAg, VDRL & Malaria</strong></p>
            <div class="date-info">
              <div>
                <p>Donation Date:<strong>${
                  product?.blood_donation?.date_added ? new Date(product?.blood_donation?.date_added).toLocaleString() : 'N/A'}</strong>                  
                </p>
              </div>
              <div>
                <p>Expiry Date:<strong> ${product.expiry_date ? new Date(product.expiry_date).toLocaleString() : 'N/A' }</strong></p>
              </div>
            </div>
            <div class="barcode-container">
              <img src="${barcodeSrc}" alt="Barcode" class="barcode">
            </div>
          </div>
          </div>
        `;

        // Prepare the full document for printing
        const printDocument = `
          <html>
          <head>
            <title>Print Preview</title>
            <style>
              body {
                font-family: Manjari, sans-serif;
                text-align: center;
                margin: 0;
                padding: 0;
              }
              .page-container {
                width: 100vw;
                height: 100vh;
                display: flex;
                justify-content: center;
                align-items: center;
              }
              .sticker-container {
                margin: auto;
                width: 500px;  /* Fixed width for the content */
                padding: 20px;
                background-color: white;
              }
              .logo-container {
                display: flex;
                justify-content: center;
                margin-bottom: 10px;
              }
              .logo {
                height: 100px;
              }
              .blood-group-container {
                display: flex;
                justify-content: space-between;
              }
              .blood-group {
                margin-top: 20px;
                text-align: center;
              }
              .blood-group h1 {
                font-size: 70px;
                margin: 0;
              }
              .blood-group p {
                font-size: 20px;            
              }
              .product-info {
                text-align: left;
                padding: 10px 0 0 30px;
              }
              .product-info p {
                font-size: 20px;
              }
              .negative-results {
                font-size: 20px;
                margin-bottom: 18px;
              }
              .date-info {
                margin-bottom: 10px;
              }
              .date-info p {
                font-size: 20px;
              }
              .barcode-container {
                display: flex;
                justify-content: center;
                margin-bottom: 5px;
              }
              .barcode {
                width: 50%;
              }
              @media print {
                @page {
                  size: A8;
                  margin: 0;
                }
                body {
                  margin: 0;
                  padding: 0;
                  display: flex;
                  align-items: center;
                  justify-content: center;
                  height: 100%;
                }
                .sticker-container {
                  width: auto;
                  margin: 0;
                  padding: 10px;
                }

                .hollow-text {
                  color: transparent;
                  -webkit-text-stroke: 1px black;  // For Webkit browsers (Chrome, Safari)
                  text-stroke: 1px black;          // Standard syntax (future-proofing)
                }
              }
            </style>
          </head>
          <body>
            ${printContent}
          </body>
          </html>
        `;

        // Open the print document
        printWindow.contentDocument.open();
        printWindow.contentDocument.write(printDocument);
        printWindow.contentDocument.close();

        // Print when the document is loaded
        printWindow.contentWindow.onload = function () {
          printWindow.contentWindow.print();
        };
      } catch (error) {
        this.error = error.message || 'Failed to fetch donation';
      } finally {
        this.isLoading[productId] = false
     }
    },

    generateBarcode(pintSerial) {
      const canvas = document.createElement('canvas');
      JsBarcode(canvas, pintSerial, { format: 'CODE128' });
      return canvas.toDataURL('image/png');
    },

  },
};
</script>

<style lang="css" scoped></style>